"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var translations_context_1 = __importDefault(require("./translations.context"));
function useTranslations() {
    return react_1.useContext(translations_context_1.default);
}
exports.default = useTranslations;
//# sourceMappingURL=use-translations.hook.js.map